export const getFilteredData = (
  prodArr,
  InStock,
  OutStock,
  startPrice,
  endPrice,
) => {
  let priceArray = prodArr.filter((product) => {
    return product.productcost;
  });

  let priceRangeArray = priceArray.filter((e) => {
    return e.productcost >= startPrice && e.productcost <= endPrice;
  });
  let filteredArr = prodArr.filter((product) => {
    if ((OutStock && InStock) || (!OutStock && !InStock)) {
      return product;
    }
    if (OutStock) {
      return product.itemcount === 0;
    }
    if (InStock) {
      return product.itemcount !== 0;
    }
  });

  if (priceRangeArray.length) {
    let filteredPriceArray = filteredArr.filter(function (e) {
      return priceRangeArray.indexOf(e) > -1;
    });
    return filteredPriceArray;
  } else {
    return filteredArr;
  }
};
